import RevealOnScroll from '../base/RevealOnScroll';

const steps = [
  {
    number: '01',
    title: 'Request Free Quote',
    description: 'Use our simple form or call 346-363-8363 to describe your project. We provide a detailed estimate with no obligation and no pressure — just honest, upfront pricing.',
    image: 'https://public.readdy.ai/ai/img_res/6cbcd01277f5885dc80dea5b24c4cad3.jpg',
    icon: 'ri-file-list-3-line',
  },
  {
    number: '02',
    title: 'Review & Plan Together',
    description: 'We walk through every detail of your project with you — scope, timeline, materials, and process. No surprises. You have full visibility before a single tool is picked up.',
    image: 'https://readdy.ai/api/search-image?query=contractor%20explaining%20renovation%20plan%20homeowner%20meeting%20luxury%20home%20interior%20professional%20consultation%20friendly%20skilled%20expert%20planning%20discussion%20warm%20bright%20Houston%20residential&width=600&height=600&seq=proc-002&orientation=squarish',
    icon: 'ri-discuss-line',
  },
  {
    number: '03',
    title: 'We Deliver Excellence',
    description: 'Our professional team arrives equipped and ready. We complete every Houston project on time, with skilled craftsmanship and backed by our full 100% satisfaction guarantee.',
    image: 'https://readdy.ai/api/search-image?query=skilled%20craftsman%20precision%20installation%20work%20luxury%20home%20renovation%20professional%20tools%20high%20quality%20workmanship%20close%20up%20expert%20hands%20at%20work%20Houston%20Texas%20home%20improvement&width=600&height=600&seq=proc-003&orientation=squarish',
    icon: 'ri-award-line',
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-[#0F0F0F] py-28 lg:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <RevealOnScroll className="mb-18">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-px bg-[#BF9448]" />
            <span className="text-[#BF9448] text-[10px] font-sans font-semibold tracking-[0.25em] uppercase">
              How It Works
            </span>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
            <h2
              className="font-serif font-semibold text-white leading-tight"
              style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
            >
              Simple. Transparent. Professional.
            </h2>
            <a
              href="#quote"
              className="self-start lg:self-auto flex items-center gap-2 bg-[#BF9448] hover:bg-[#D4AB5E] text-white font-sans text-xs font-semibold px-7 py-3.5 rounded-sm transition-colors duration-200 whitespace-nowrap cursor-pointer tracking-[0.12em] uppercase"
            >
              Start with a Free Quote
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </RevealOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 lg:gap-px bg-white/5">
          {steps.map((step, i) => (
            <RevealOnScroll key={i} delayMs={i * 120}>
              <div className="group bg-[#0F0F0F] hover:bg-[#141210] transition-colors duration-400 p-0 lg:p-8 lg:pb-10 relative overflow-hidden">
                {/* Large decorative number */}
                <div
                  className="font-serif font-bold text-white/4 leading-none select-none pointer-events-none mb-0 absolute top-4 right-6 lg:static lg:mb-3"
                  style={{ fontSize: 'clamp(5rem, 10vw, 8rem)' }}
                >
                  {step.number}
                </div>

                {/* Image */}
                <div className="relative h-64 overflow-hidden mb-7">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  {/* Step number badge */}
                  <div className="absolute top-4 left-4">
                    <div className="bg-[#BF9448] text-white font-sans font-bold text-xs px-3 py-1.5 tracking-widest">
                      STEP {step.number}
                    </div>
                  </div>
                  {/* Icon overlay */}
                  <div className="absolute bottom-4 right-4">
                    <span className="w-10 h-10 flex items-center justify-center border border-white/20 bg-black/40 backdrop-blur-sm">
                      <i className={`${step.icon} text-[#BF9448] text-lg`}></i>
                    </span>
                  </div>
                </div>

                <div className="pt-2">
                  <h3 className="font-serif text-white text-xl font-semibold mb-3">{step.title}</h3>
                  <p className="font-sans text-white/45 text-sm leading-relaxed">{step.description}</p>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-px bg-[#BF9448]/0 group-hover:bg-[#BF9448]/40 transition-colors duration-400" />
              </div>
            </RevealOnScroll>
          ))}
        </div>

      </div>
    </section>
  );
}
